module.exports = __webpack_public_path__ + "static/media/google_powerpoint.111f1ee1.svg";